<template>
  <div>
    <div class="mobile">
      <section class="m-hero">
        <h1>Linker</h1>
        <p>
          오래된 에어컨, TV 이제는
          <br>스마트폰으로 켜고 끄세요
        </p>
      </section>
      <section class="m-linker-description-first">
        <div class="m-description-container">
          <span>
            무더운 여름
            <br>미리 에어컨 켜고 귀가하세요
          </span>
          <p>
            Wi-Fi가 있다면 링커로 집 안 모든 전자제품을
            <br>언제 어디서나 앱에서 제어할 수 있어요.
          </p>
        </div>
        <div style="margin-top: 45px;">
          <img
            src="@/assets/linker/m-aircon-control.gif"
            style="width: 80%;"
          >
          <p style="font-size: 12px; margin-top: 8px; color: #868fa3;">에어컨 켜기</p>
        </div>
      </section>
      <section class="m-linker-description-youtube">
        <div class="video-wrapper">
          <div class="video-cover" @click="playBtnClick" v-bind:class="{removeCover: isPlaying}">
            <div class="play-icon"></div>
          </div>
          <iframe
            id="ytplayer"
            type="text/html"
            width="640"
            height="360"
            src="https://www.youtube.com/embed/jfZ3vbxZjt8?enablejsapi=1&html5=1"
            frameborder="0"
          />
        </div>
      </section>
      <section class="m-linker-description-reservation">
        <div class="m-description-container">
          <span>예약해서 써보세요</span>
          <p>
            예약해서 에어컨을 켜고 끄세요
            <br>시원하게 귀가할 수 있고
            <br>전기세를 아낄 수 있습니다.
          </p>
        </div>
      </section>
      <section class="m-linker-description-reservation-image"></section>
      <section class="m-linker-description-speaker hideAll">
        <div class="m-description-container">
          <span>앱을 켤 필요 없어요. 말을 걸어 보세요</span>
          <p>
            퇴근하고 피곤할 때 스마트폰 음성제어*로
            <br>손가락 까딱하지 않고 링커를 통해
            <br>스위처를 제어할 수 있습니다.
            <br>*iPhone Siri, 클로바
          </p>
          <img id="linker" src="@/assets/linker/m-linker-front.png" alt>
          <img id="ai-speaker" src="@/assets/linker/ai-icons.png" alt>
        </div>
      </section>
      <section class="m-linker-description-push-message">
        <div class="m-description-container">
          <span>집 온도변화를 확인하세요.</span>
          <p>
            링커에 탑재된 온도, 조도, 사운드 센서가
            <br>집 안의 변화를 체크해
            <br>사용자에게 차트로 보여줍니다.
          </p>
          <img style="width: 350px;" src="@/assets/linker/m-device.png" alt>
        </div>
      </section>
      <section class="m-linker-description-connect">
        <div class="m-description-container">
          <span>
            Linker와 전자제품
            <br>연동 어렵지 않아요
          </span>
          <p>
            링커에 Wi-Fi를 연결한 후 전용 앱에서
            <br>사용하는 전자제품 브랜드*를 등록하면
            <br>끝.너무나 손쉽게 연동할 수 있어요.
          </p>
          <p>*LG, 삼성, 캐리어, 위니아, 대우(Hisense 제조)</p>
        </div>
      </section>
      <section class="m-linker-description-connect-image"></section>
      <section class="m-linker-description-design">
        <div class="m-description-container">
          <span>작아도 놓칠 수 없는 디자인</span>
          <p>
            링커는 한 손에 쏙 들어오는 부담 없는 사이즈로
            <br>어떤 공간에 놓아도 조화롭게 어울리는
            <br>세련된 유광 블랙 컬러가 공간을 더 멋지게 연출합니다.
          </p>
        </div>
      </section>
      <section class="m-linker-description-switcher">
        <div class="m-description-container">
          <span>
            스위처와 함께 사용해보세요
            <br>집 안에서도 밖에서도
            <br>언제 어디서나 조명을 켜고 끌 수 있어요
          </span>
        </div>
      </section>
      <section class="m-linker-description-seventh">
        <div class="m-description-container">
          <span>
            링커를 전용 앱으로 사용하세요.
            <br>앱을 다운받으면 휴대폰으로
            <br>원격 제어, 모니터링이 가능합니다.
          </span>
          <div class="button-wrapper">
            <a
              href="https://itunes.apple.com/kr/app/%EC%8A%A4%EC%9C%84%EC%B2%98/id1085468372?mt=8"
              target="_blank"
            >
              <div class="app-button">
                <img style="width: 18px; height: 20px;" src="@/assets/main/app-store.png" alt>
                <span>App Store</span>
              </div>
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=kr.switcher.switcherm&hl=ko"
              target="_blank"
              class="hideAll"
            >
              <div class="app-button hidden">
                <img style="width: 16px; height: 19px;" src="@/assets/main/google-play.png" alt>
                <span>Google Play</span>
              </div>
            </a>
          </div>
        </div>
      </section>
      <section class="m-usecase">
        <div class="m-usecase-container">
          <h3>
            Linker 이렇게
            <br>활용해 보세요
          </h3>
          <div class="m-usecase-contents">
            <span>Switcher와 함께 사용해보세요</span>
            <p>
              스위처가 있다면 링커로 조명 제어도 가능합니다.
              <br>집 안에서도, 밖에서도 언제 어디서나
              <br>점등, 소등을 할 수 있어요.
            </p>
            <p style="font-size: 12px">*스위처는 1대만 제어가 가능합니다.(최대 5대 확장 예정)</p>
          </div>
          <div class="m-usecase-contents hideAll">
            <span>앱을 켤 필요도 없어요, 말을 걸어보세요</span>
            <p>
              퇴근하고 피곤할 때, 스마트폰 음성제어*로
              <br>손가락 까딱하지 않고 링커를 통해
              <br>스위처를 제어할 수 있습니다.
              <br>*iPhone Siri
            </p>
          </div>
          <div class="m-usecase-contents">
            <span>
              전자제품을 켜고 나왔어도 걱정마세요,
              <br>링커가 알려줍니다
            </span>
            <p>
              링커에는 온도, 조도, 사운드 센서가 탑재되어 있어
              <br>집 안의 변화를 실시간으로 모니터링합니다.
              <br>게다가 사용자의 사용 패턴을 분석해
              <br>평소와 다른 기기 변화가 감지되면
              <br>앱으로 즉각 피드백을 보내줍니다.
            </p>
          </div>
        </div>
      </section>
    </div>
    <div class="desktop">
      <section class="hero">
        <div class="main-title-container">
          <span>
            오래된 에어컨, TV 이제는
            <br>스마트폰으로 켜고 끄세요
          </span>
        </div>
      </section>
      <section class="linker-description-first">
        <div>
          <span class="center-title">명절 또는 잦은 출장으로 집을 오랜 기간 비워야 할 때가 있죠</span>
          <p class="center-subtitle">
            Wi-Fi가 있다면 링커로 집 안 모든 전자제품을
            <br>언제 어디서나 앱에서 제어할 수 있어요.
          </p>
          <img src="@/assets/wifi.gif" style="width: 38px; height: 38px; margin-top: 20px;" alt>
          <p style="font-size: 12px; margin-top: 8px; color: #868fa3;">TV 연결하기</p>
        </div>
      </section>
      <section class="linker-description-youtube">
        <div class="video-wrapper">
          <div class="video-cover" @click="playBtnClick" v-bind:class="{removeCover: isPlaying}">
            <div class="play-icon"></div>
          </div>
          <iframe
            id="ytplayer"
            type="text/html"
            width="640"
            height="360"
            src="https://www.youtube.com/embed/jfZ3vbxZjt8?enablejsapi=1&html5=1"
            frameborder="0"
          />
        </div>
      </section>
      <section class="linker-description-switcher">
        <div>
          <span class="description-title">스위처와 함께 사용해보세요</span>
          <p class="description-subtitle">
            집 안에서도 밖에서도
            <br>언제 어디서나 조명을 켜고 끌 수 있어요
          </p>
        </div>
      </section>
      <section class="linker-description-reservation">
        <div>
          <span class="description-title">예약해서 써보세요</span>
          <p class="description-subtitle">
            설정한 시간에 맞춰 집 안의 조명과 전자제품이
            <br>켜지도록 예약기능을 사용해보세요.
            <br>퇴근 후 어두운 집 안에 들어갔다면
            <br>이제는 밝고 쾌적한 집 안으로 들어갈 수 있어요.
          </p>
        </div>
      </section>
      <section class="linker-description-speaker hideAll">
        <div>
          <span class="description-title">앱을 켤 필요 없어요. 말을 걸어보세요</span>
          <p class="description-subtitle">
            퇴근하고 피곤할 때 스마트폰 음성제어*로
            <br>손가락 까딱하지 않고 링커를 통해
            <br>스위처를 제어할 수 있습니다.
          </p>
          <p class="description-subtitle" style="font-weight: normal;">*iPhone Siri, 클로바</p>
          <img src="@/assets/linker/linker-front.png" alt>
          <img id="ai-speaker" src="@/assets/linker/ai-icons.png" alt>
        </div>
      </section>
      <section class="linker-description-push-message">
        <div>
          <span class="center-title">전등이 켜졌는지, 전자제품 전원이 꺼졌는지, 밖에서도 바로 확인해요</span>
          <p class="center-subtitle">
            링커에 탑재된 온도, 조도, 사운드 센서가 집 안의 변화를 체크해
            <br>사용자에게 차트로 보여줍니다.
          </p>
          <img style="width: 550px;" src="@/assets/linker/m-device.png" alt>
        </div>
      </section>
      <section class="linker-description-connect">
        <div>
          <span class="description-title">Linker와 전자제품 연동 어렵지 않아요</span>
          <p class="description-subtitle">
            링커에 Wi-Fi를 연결한 후 전용 앱에서
            <br>사용하는 전자제품 브랜드*를 등록하면 끝.
            <br>너무나 손쉽게 연동할 수 있어요.
          </p>
          <p class="description-subtitle" style="font-weight: normal;">*LG, 삼성, 캐리어, 위니아</p>
        </div>
      </section>
      <section class="linker-description-design">
        <div>
          <span class="description-title">작아도 놓칠 수 없는 디자인</span>
          <p class="description-subtitle">
            크건 작건 전자제품을 살 땐 집 분위기와 어울리는지
            <br>한 번 더 생각해보게 되죠. 링커는 한 손에 쏙 들어오는
            <br>부담 없는 사이즈로, 어떤 공간에 놓아도 조화롭게 어울리는
            <br>세련된 유광 블랙 컬러가 공간을 더 멋지게 연출합니다.
          </p>
        </div>
      </section>
      <section class="linker-description-seventh">
        <div>
          <span>
            링커를 전용 앱으로 사용하세요
            <br>앱을 다운받으면 휴대폰으로 원격 제어, 모니터링이 가능합니다
          </span>
        </div>
        <div class="button-wrapper">
          <a
            href="https://itunes.apple.com/kr/app/%EC%8A%A4%EC%9C%84%EC%B2%98/id1085468372?mt=8"
            target="_blank"
          >
            <div class="app-button">
              <img style="width: 18px; height: 20px;" src="@/assets/main/app-store.png" alt>
              <span style="font-size: 14px">App Store</span>
            </div>
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=kr.switcher.switcherm&hl=ko"
            target="_blank"
            class="hideAll"
          >
            <div class="app-button">
              <img style="width: 16px; height: 19px;" src="@/assets/main/google-play.png" alt>
              <span style="font-size: 14px">Google Play</span>
            </div>
          </a>
        </div>
      </section>
      <section class="linker-description-eighth">
        <div>
          <span class="usecase-title">
            Linker 이렇게
            <br>활용해 보세요
          </span>
        </div>
        <div class="usecase-wrapper">
          <div class="usecase-contents" style="margin-top: 0;">
            <span>Switcher와 함께 사용해보세요</span>
            <p>
              스위처가 있다면 링커로 조명 제어도 가능합니다.
              <br>집 안에서도, 밖에서도 언제 어디서나 점등, 소등을 할 수 있어요.
            </p>
            <p style="font-size: 12px">*스위처는 1대만 제어가 가능합니다.(최대 5대 확장 예정)</p>
          </div>
          <div class="usecase-contents hideAll">
            <span>앱을 켤 필요도 없어요, 말을 걸어보세요</span>
            <p>
              퇴근하고 피곤할 때, 스마트폰 음성제어*로 손가락 까딱하지 않고
              <br>링커를 통해 스위처를 제어할 수 있습니다. *iPhone Siri
            </p>
            <!-- <a href="">영상으로 확인하기</a> -->
          </div>
          <div class="usecase-contents">
            <span>전자제품을 켜고 나왔어도 걱정마세요, 링커가 알려줍니다</span>
            <p>
              링커에는 온도, 조도, 사운드 센서가 탑재되어 있어
              <br>집 안의 변화를 실시간으로 모니터링합니다. 게다가 사용자의 사용 패턴을 분석해
              <br>평소와 다른 기기 변화가 감지되면 앱으로 즉각 피드백을 보내줍니다.
            </p>
            <!-- <a href="">영상으로 확인하기</a> -->
          </div>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
export default {
  name: 'linker-summary',
  data () {
    return {
      isPlaying: false
    }
  },
  methods: {
    playBtnClick: function () {
      this.isPlaying = true
    }
  }
}

</script>
<style scoped>

.desktop section {
  margin-bottom: 30px;
}

.hero {
  background: url("../../../assets/linker/linker-hero.png") no-repeat center
    center;
  background-size: cover;
  min-height: 500px;
  display: flex;
  align-items: center;
}

.hero span {
  font-size: 24px;
  font-weight: bold;
  line-height: 1.58;
  letter-spacing: 0;
  color: #ffffff;
}

.description-title {
  font-size: 24px;
  font-weight: 500;
}
.description-subtitle {
  margin: 0;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.62;
  margin-top: 13px;
}
.center-title {
  font-size: 24px;
  letter-spacing: 0;
  font-weight: 500;
}
.center-subtitle {
  font-size: 16px;
  font-weight: 400;
  line-height: 1.62;
  margin-top: 15px;
}

.linker-description-first {
  width: 100%;
  min-height: 500px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.linker-description-youtube {
  min-height: 654px;
  display: flex;
  justify-content: center;
}
.linker-description-youtube .video-wrapper {
  position: relative;
  width: 80%;
}
.linker-description-youtube .video-wrapper .video-cover {
  background: url("../../../assets/linker/linker_youtube_cover.png") no-repeat center center;
  background-size: cover;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}

.linker-description-youtube .video-wrapper .video-cover:hover .play-icon {
  opacity: 1;
}
.play-icon {
  background: url("../../../assets/linker/play-btn.png") no-repeat center;
  background-size: cover;
  width: 60px;
  height: 60px;
  opacity: 0.5;
}

#ytplayer {
  width: 100%;
  height: 100%;
}

.removeCover {
  display: none !important;
}

.linker-description-switcher {
  background: url("../../../assets/main/switcher.png")
    no-repeat center center;
  background-size: cover;
  min-height: 500px;
  display: flex;
  align-items: center;
}
.linker-description-switcher div {
  text-align: left;
  margin-left: 265px;
}

.linker-description-reservation {
  background: url("../../../assets/linker/linker-description-reservation.png")
    no-repeat center center;
  background-size: cover;
  min-height: 600px;
  display: flex;
  align-items: unset;
}
.linker-description-reservation div {
  text-align: left;
  margin-left: 265px;
  padding-top: 350px;
}
.linker-description-design {
  background: url("../../../assets/linker/linker-description-design.png")
    no-repeat center center;
  background-size: cover;
  min-height: 540px;
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  color: #ffffff;
}
.linker-description-design div {
  text-align: left;
  flex: 0.45;
}
.linker-description-connect {
  background: url("../../../assets/linker/linker-description-fourth.png")
    no-repeat center center;
  background-size: cover;
  min-height: 500px;
  display: flex;
  align-items: center;
}
.linker-description-connect div {
  text-align: left;
  margin-left: 265px;
}
.linker-description-speaker {
  padding: 142px 0px 142px 0px;
}
.linker-description-speaker img {
  margin-top: 61px;
}
.linker-description-speaker #ai-speaker {
  width: 180px;
  display: block;
  margin: 0 auto;
  margin-top: 24px;
}
.linker-description-push-message {
  padding-top: 120px;
  background-color: #fafafa;
}
.linker-description-push-message img {
  margin-top: 78px;
}
.linker-description-seventh {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  min-height: 360px;
}
.linker-description-seventh span {
  font-size: 20px;
  line-height: 1.7;
  color: #3d4953 !important;
 }
.linker-description-seventh .button-wrapper {
  display:flex;
}

.button-wrapper {
  display: inline-block;
  margin-top: 36px;
}
.button-wrapper div {
  margin: 7px;
}
.app-button {
  width: 158px;
  height: 50px;
  border-radius: 2px;
  border: solid 1px #a5a5a5;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #3d4953;
}
.app-button:hover {
  border: solid 1px #3d4953;
}

.app-button span {
  font-size: 16px !important;

}
.app-button img {
  margin-right: 7px;
}

.linker-description-eighth {
  width: 100%;
  display: flex;
  background-color: #fafafa;
  justify-content: space-evenly;
  padding-top: 100px;
  padding-bottom: 100px;
}

.desktop .usecase-contents {
  text-align: left;
}
.desktop .usecase-contents p {
  font-weight: 400;
}
.usecase-contents {
  font-size: 16px;
  line-height: 1.71;
  margin-top: 39px;
}
.usecase-contents span {
  font-weight: bold;
}
.usecase-contents p {
  margin-top: 9px;
}
.usecase-contents a {
  font-size: 12px;
  letter-spacing: -0.4px;
  color: #3d4953;
  text-decoration: underline;
}

.main-title-container {
  text-align: left;
  margin-left: 10%;
}
.m-hero {
  background: url("../../../assets/linker/m-linker-hero.png") no-repeat center
    center;
  background-size: cover;
  min-height: 470px;
  text-align: left;
  padding: 41px 0px 0px 26px;
}
.m-hero h1 {
  font-size: 18px;
  font-weight: bold;
  color: #ffffff;
}
.m-hero p {
  margin-top: 24px;
  font-size: 18px;
  line-height: 1.56;
  color: #ffffff;
}

.m-description-container {
  text-align: left;
}
.m-description-container span {
  font-size: 18px;
  line-height: 1.56;
  letter-spacing: 0;
  font-weight: bold;
}
.m-description-container p {
  margin: 23px 0px 0px 0px;
  font-size: 14px;
  line-height: 1.71;
  letter-spacing: 0;
}
.m-linker-description-youtube {
  height: 300px;
  display: flex;
  justify-content: center;
}

.m-linker-description-youtube .video-wrapper {
  position: relative;
  width: 90%;
  height: 80%;
}

.m-linker-description-youtube .video-wrapper .video-cover {
  background: url("../../../assets/linker/linker_youtube_cover.png") no-repeat center center;
  background-size: 100% 100%;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}
.m-linker-description-first {
  width: 100%;
  min-height: 480px;
  padding-top: 71px;
}
.m-linker-description-first .m-description-container {
  margin-left: 25px;
}
.m-linker-description-switcher {
  width: 100%;
  min-height: 543px;
  background: url("../../../assets/linker/m-linker-description-switcher.png") no-repeat center center;
  background-size: cover;
  padding-top: 53px;
  display: flex;
  justify-content: center;
}
.m-linker-description-switcher .m-description-container {
  text-align: center;
  font-weight: bold;
}

.m-linker-description-reservation {
  padding: 72px 0px 54px 26px;
}

.m-linker-description-reservation .m-description-container {
  text-align: left;
}

.m-linker-description-reservation p {
  margin: 23px 0px 0px 0px;
  font-size: 14px;
  line-height: 1.71;
  letter-spacing: 0;
}

.m-linker-description-reservation-image {
  background: url("../../../assets/linker/m-linker-description-reservation-image.png") no-repeat center center;
  background-size: cover;
  min-height: 356px;
}

.m-linker-description-design {
  background: url("../../../assets/linker/m-linker-description-design.png")
    no-repeat center center;
  background-size: cover;
  min-height: 548px;
  color: #ffffff;
  padding-top: 60px;
}
.m-linker-description-design .m-description-container {
  text-align: center;
}
.m-linker-description-speaker {
  text-align: center;
  min-height: 470px;
  padding-top: 90px;
}
.m-linker-description-speaker .m-description-container {
  text-align: center;
}
.m-linker-description-speaker #linker {
  margin-top: 40px;
}
.m-linker-description-speaker #ai-speaker {
  width: 100px;
  display: block;
  margin: 0 auto;
  margin-top: 12px;
}
.m-linker-description-connect {
  padding: 72px 0px 54px 26px;
}
.m-linker-description-connect .m-description-container {
  text-align: left;
}
.m-linker-description-connect-image {
  background: url("../../../assets/linker/m-linker-description-connect-image.png") no-repeat center center;
  background-size: cover;
  min-height: 447px;
}
.m-linker-description-push-message {
  min-height: 548px;
  background-color: #fafafa;
  position: relative;
  padding-top: 90px;
}
.m-linker-description-push-message .m-description-container {
  text-align: center;
}
.m-linker-description-push-message img {
  position: absolute;
  bottom: 0;
  left: 50%;
  -webkit-transform: translate(-50%);
  transform: translate(-50%);
}
.m-linker-description-seventh {
  min-height: 497px;
  display: flex;
  align-items: center;
}
.m-linker-description-seventh .m-description-container {
  text-align: center;
}

.app-button {
  width: 158px;
  height: 50px;
  border-radius: 2px;
  border: solid 1px #a5a5a5;
  display: flex;
  align-items: center;
  justify-content: center;
}
.app-button img {
  margin-right: 7px;
}

.m-usecase {
  background-color: #fafafa;
  padding: 73px 0px 110px 25px;
}

.m-usecase-container {
  text-align: left;
}
.m-usecase-container h3 {
  font-size: 18px;
  line-height: 1.56;
}
.m-usecase-container span {
  line-height: 1.56;
}
.m-usecase-contents {
  font-size: 14px;
  line-height: 1.71;
  margin-top: 39px;
}
.m-usecase-contents span {
  font-weight: bold;
}
.m-usecase-contents p {
  margin-top: 9px;
}
.m-usecase-contents a {
  font-size: 12px;
  letter-spacing: -0.4px;
  color: #3d4953;
  text-decoration: underline;
}

.linker-description-eighth div {
  text-align: left;
  font-weight: 500;
}
.linker-description-eighth .usecase-title {
  font-size: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/products/linker/LinkerSummary.vue